import { Chip } from "@mui/material";
import { extractArrayFromManyToMany } from "../../utils";

export type ElectrodesLocation = {
    name: string;
};

type ElectrodeLocationsProps = {
    electrodesLocations: ElectrodesLocation[];
};

export const ElectrodeLocations = ({ electrodesLocations }: ElectrodeLocationsProps) => {
    const extractedElectrodeLocations = extractArrayFromManyToMany(
        electrodesLocations,
        "electrodes_locations"
    ) as ElectrodesLocation[];

    const locationsLabel = extractedElectrodeLocations.map((location) => location.name).join(" - ");

    return <Chip label={locationsLabel} />;
};
